import { StateService } from '@infra/state/state.service';
import { inject, Injectable } from '@angular/core';
import { type ActivatedRouteSnapshot, type Resolve } from '@angular/router';
import { CustomerService } from '@api/services/customer.service';
import { type Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class CustomerResolver implements Resolve<boolean> {
  private readonly stateService = inject(StateService);
  private readonly customerService = inject(CustomerService);

  resolve(route: ActivatedRouteSnapshot): Observable<boolean> | boolean {
    const customerId = route.paramMap.get('customerId');
    return this.customerService.getById(customerId).pipe(
      map(() => {
        this.stateService.setAssignment(null);
        this.stateService.setAccount(null);
        this.stateService.setBookingAgent(null);
        return true;
      })
    );
  }
}
